package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TradePrice(
    @SerialName("count")
    val count: Double?,
    @SerialName("price")
    val price: Double?,
    @SerialName("__typename")
    val typename: String?
)